import React from "react";
import { Form, Input, Select } from "antd";

function BasicDataSection({
  dataProjects,
  counties,
  onProjectChange,
  onLoadProjects,
}) {
  return (
    <>
      <div className="custom-title !bg-white !p-0">Project Basic Data</div>
      <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
        <Form.Item
          name="mrProjectName"
          className=""
          label={"Project Name"}
          rules={[
            {
              required: true,
              message: "Please select project name",
            },
          ]}
        >
          <Select
            className=""
            allowClear
            style={{
              width: "100%",
            }}
            options={dataProjects?.map((item) => {
              return {
                value: item?.projectName,
                label: item?.projectName,
              };
            })}
            onChange={onProjectChange}
            onDropdownVisibleChange={() => onLoadProjects(null)}
            showSearch
            onSearch={(value) => onLoadProjects(value || null)}
            optionFilterProp="label"
            filterOption={false}
          />
        </Form.Item>
        <Form.Item
          name="mrProjectId"
          className="hidden"
          label={"Project Id"}
          rules={[
            {
              required: true,
              message: "Please select project id",
            },
          ]}
        >
          <Input disabled className="input " />
        </Form.Item>
        <Form.Item
          name="mrProjectNo"
          className=""
          label={"Project Number"}
          rules={[
            {
              required: true,
              message: "Please select project number",
            },
          ]}
        >
          <Input disabled className="input" />
        </Form.Item>
        <Form.Item
          name="mrCountyId"
          label="County"
          rules={[{ required: true, message: "Please select county" }]}
        >
          <Select
            disabled
            allowClear
            options={counties?.map((c) => ({
              value: c?.countyId,
              label: c?.countyName,
            }))}
            showSearch
            filterOption={(input, option) =>
              option?.label?.toLowerCase()?.includes(input.toLowerCase())
            }
          />
        </Form.Item>
      </div>
    </>
  );
}

export default BasicDataSection;
